function LineLoader() {
  return (
    <>
      <div className="blurry">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
}

export default LineLoader;
